export default (props, vars) =>
  vars?.['useapplicationsstatus2']?.['applicationStatus'].find(
    ({ application_id }) =>
      application_id == vars?.['usestateappdetailspopup']?.['state']
  );
